import DialogContext from 'Contexts/DialogContext';
import { useContext } from 'react';

const useDialog = () => {
  return useContext(DialogContext);
};

export default useDialog;
